<template>
	<div>
		<vs-prompt :active.sync="active" title="Price Drop Message" accept-text="Send now" v-on:accept="$emit('accept')">

			<vs-input name="mailTo" label-placeholder="Email address" v-model="result.email" class="w-full mb-6" />


			<quill-editor class="editor1" v-model="mailMessage" :options="editorOption" />
			<div class="px-3 pt-1 pb-1 fake-editor">
				<vs-card class="mb-0">
					<div class="flex items-center justify-between">
						<div>{{result.offer.title}}</div>
						<div>
							<img
							src="/../cruise-line-logos/carnival.svg"
							class="max-w-full"
							width="24"
							style="max-height: 24px"/>
						</div>
						<div>
							{{result.offer.date}}
						</div>
						<div>
							{{result.offer.cabin}}
						</div>
						<div class="flex items-center">
							<span><span class="text-xl">{{result.offer.price}}&nbsp;</span> <span class="text-primary">{{result.offer.reduction}}</span></span>
						</div>
					</div>
				</vs-card>
			</div>
			<quill-editor class="editor2" v-model="mailMessage2" :options="editorOption2" />
		</vs-prompt>
	</div>
</template>


<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

export default {
	data() {
		return {
			active: true,
			mailMessage: '<p>Hi '+this.result.firstname+',</p><p>'+this.result.mailMessage+'</p>',
			mailMessage2: '<p>Should we have a quick chat to book the cruise?</p><p>Best regards</p><p>Jennifer</p>',
			editorOption: {
				modules: {
				toolbar: [
					['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
					[{ 'header': 1 }, { 'header': 2 }],
					[{ 'list': 'ordered' }, { 'list': 'bullet' }],
					[{ 'font': [] }]
				]
				},
				placeholder: 'Message'
			},
			editorOption2:
			{
				modules: {
					"toolbar": false
				},
				placeholder: 'Message'
			},
		};
	},
	props: {
		result: {
			type: Object,
			required: true,
		},
	},
	components: {
	    quillEditor,

	}
};
</script>

<style lang="scss">
	.editor1 .ql-container.ql-snow {
		border-bottom: none;
	}
	.editor2 .ql-container.ql-snow {
		border-top: none;
	}
	.fake-editor {
		border-left: 1px solid #ccc;
		border-right: 1px solid #ccc;
	}
</style>
